
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fastdebtconsolidation",
      function () {
        return require("private-next-pages/fastdebtconsolidation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fastdebtconsolidation"])
      });
    }
  